export default __webpack_public_path__ + "static/media/yellowSpinner.e61bf378.svg";